import React from 'react';
import classnames from 'classnames';

import './styles.scss';

export interface StepProgressProps {
    selectedStep: number;
    setSelectedStep: Function;
    steps: Step[];
}

export interface Step {
    description: string;
    value: number;
}

export default function StepProgress(
    props: StepProgressProps
): React.ReactElement {
    const { steps, selectedStep, setSelectedStep } = props;
    const maxWidthStyle = `${100 / steps.length}%`;

    return (
        <section className="step-progress">
            <ol className="step-progress-list">
                {steps.map(({ description, value }: Step) => {
                    const stepStatusClass = classnames('step-progress-item', {
                        completed: selectedStep > value,
                        selected: selectedStep === value
                    });

                    return (
                        <li
                            className={`step-progress-item ${stepStatusClass}`}
                            style={{ maxWidth: maxWidthStyle }}
                            key={value}
                        >
                            <span
                                aria-hidden
                                className={`circle ${stepStatusClass}`}
                            />
                            <button
                                type="button"
                                className="step-progress-item-button"
                                onClick={(): void => setSelectedStep(value)}
                            >
                                {description}
                            </button>
                        </li>
                    );
                })}
            </ol>
        </section>
    );
}
